export default "__VITE_ASSET__D9w2gW8v__"